<template>
    <div>
        <div v-if="noToken" class="paygo-notification">
            {{
                $t('paygo.tokenInfo.noTokenInfo', {
                    i18nFallback:
                        'You have fully paid off all costs of this PAYGo installation.Therefore you have no tokens.',
                })
            }}
        </div>
        <div v-if="isPaid && !noToken" class="paygo-notification">
            {{
                $t('paygo.tokenInfo.title', {
                    i18nFallback:
                        'You have fully paid off all costs of this PAYGo installation.Therefore you have no tokens.',
                })
            }}
        </div>
        <div v-if="!isPaid && !noToken" class="paygo-notification paygo-notification--timeleft">
            <div class="paygo-notification-token">
                <span class="paygo-notification-token-title">
                    {{ $t('paygo.tokenInfo.timeLeft', { i18nFallback: 'Time left on token' }) }}
                </span>
                <vrm-circular-progress :progress="progress">
                    <div v-if="remainingDays >= totalDays" class="paygo-circular-progress">
                        <span class="paygo-circular-progress-days-left">
                            {{ remainingDays }}
                            {{ $t('paygo.tokenGenerator.days', { i18nFallback: 'days' }) }}
                        </span>
                        <span>
                            {{ $t('paygo.tokenInfo.leftFrom', { i18nFallback: 'left from' }) }}
                        </span>
                        <span>
                            {{ totalDays }}
                            {{ $t('paygo.tokenGenerator.days', { i18nFallback: 'days' }) }}
                        </span>
                    </div>
                    <div v-if="remainingDays < totalDays" class="paygo-circular-progress">
                        <span>
                            {{ $t('paygo.tokenInfo.expired', { i18nFallback: 'Expired' }) }}
                        </span>
                        <span class="paygo-circular-progress-days-left">
                            {{ Math.abs(remainingDays) }}
                        </span>
                        <span>
                            {{ $t('paygo.tokenInfo.daysAgo', { i18nFallback: 'days ago' }) }}
                        </span>
                    </div>
                </vrm-circular-progress>
            </div>
            <div class="paygo-notification-details">
                <div class="paygo-notification-details-row">
                    <div class="paygo-notification-detail">
                        <span class="paygo-notification-detail-title">
                            {{
                                $t('paygo.tokenInfo.activatedOn', {
                                    i18nFallback: 'Paygo activated on',
                                })
                            }}
                        </span>
                        <span>{{ activationDate }}</span>
                    </div>
                    <div
                        class="
                            paygo-notification-detail
                            paygo-notification-detail--status
                        "
                    >
                        <span class="paygo-notification-detail-title">
                            {{ $t('paygo.tokenInfo.status', { i18nFallback: 'Status' }) }}
                        </span>
                        <span v-if="isActive" class="paygo-notification-detail-blue">
                            {{ $t('paygo.tokenInfo.active', { i18nFallback: 'Active' }) }}
                        </span>
                        <span v-else class="paygo-notification-detail-red">
                            {{ $t('paygo.tokenInfo.inactive', { i18nFallback: 'Inactive' }) }}
                        </span>
                    </div>
                    <div class="paygo-notification-detail">
                        <span class="paygo-notification-detail-title">
                            {{ $t('paygo.installation.token', { i18nFallback: 'Token code' }) }}
                        </span>
                        <span>{{ token }}</span>
                    </div>
                </div>
                <div class="paygo-notification-cta">
                    {{
                        $t('paygo.tokenInfo.description', {
                            i18nFallback:
                                'To input your 9-digit token code, use the num-pad on yourSHS 200 MPPT device. For more information see our How to input to PAYGo token codes or our VRM Manual',
                        })
                    }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmCircularProgress from '@/vue/components/shared/VrmCircularProgress';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
@Component({
    components: { VrmCircularProgress },
})
@AngularLocaleBundle('paygo')
export default class TokenInfo extends Vue {
    @Prop({ type: Boolean, default: false })
    noToken;
    @Prop({ type: Boolean })
    isPaid;
    @Prop({ type: Boolean })
    isActive;
    @Prop({ type: String })
    activationDate;
    @Prop()
    totalDays;
    @Prop({ type: String })
    token;
    @Prop()
    remainingDays;

    get progress() {
        let output = (this.remainingDays / this.totalDays) * 100;
        if (output < 0) output = 0;
        if (output > 100) output = 100;
        return output;
    }
}
</script>
